import { Modal } from "components"
import { EditBillService } from "../../BillService/EditBillService"

type ModalDetailBillServiceProps = {
  bill_id: number 
  toggle: () => void
}

export const ModalDetailBillService = ({ bill_id, toggle }: ModalDetailBillServiceProps) => {	
  return (
    <Modal isdarktitle isOpen title="DELIVERY BILL SERVICE DETAIL" closeModal={toggle}>
      <Modal.Body>
        <EditBillService bill_id={bill_id} disable />
      </Modal.Body>
    </Modal>
  )
}